<div
    #wrapper
    [class.tw-text-red-500]="
        deliveryNote().attachmentsCount === attachmentLimit()
    ">
    @if (!isLoading()) {
        <span
            [matTooltip]="
                'INCOMING-GOODS.CHECKIN.ATTACHMENTS-EXPLANATION' | translate
            "
            >{{ deliveryNote().attachmentsCount }} / {{ attachmentLimit() }}
            {{ 'INCOMING-GOODS.CHECKIN.ATTACHMENTS' | translate }}</span
        >
    }
    @if (isLoading()) {
        <mat-spinner [diameter]="20"></mat-spinner>
    }
</div>
